import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { BillScreen } from "../screens/BillScreen";
import { billSearch } from "../screens/purchaseSearch";

export const Route = createFileRoute("/prototype/c/$companyId/purchases/bills/$billId")({
  validateSearch: (search) => billSearch.parse(search),
  component: SupplierBill,
});

function SupplierBill() {
  const { companyId, billId } = Route.useParams();
  const { tab } = Route.useSearch();
  return (
    <BillScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      billId={billId}
      tab={tab}
    />
  );
}
